import { useState } from 'react';

import type { TCookieKey } from 'js/src/libs/consts';
import Cookies from 'js-cookie';

// for any info/upsell banners that can be dismissed, where we use a cookie to remember dismissal
export const useDismissCookie = ({
    cookieKey,
    expires = 365,
}: {
    cookieKey: TCookieKey;
    expires?: number;
}) => {
    const [isDismissed, setIsDismissed] = useState(!!Cookies.get(cookieKey));

    const onDismiss = () => {
        Cookies.set(cookieKey, 'true', { expires });
        setIsDismissed(true);
    };
    return [isDismissed, onDismiss] as const;
};
